export default __webpack_public_path__ + "b8eeb12f8d8c5e6fd8a989a0b272b4b0.svg";